import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle, longTextFormatter, booleanFormatter } from '../../../../components/tables/table'
import ConfirmDialog from '../../../../components/dialogs/ConfirmDialog'
import { getCropTypes, deleteCropType } from '../../../../../api/cropType'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(cropTypes) {
  let data = []
  for (let i = 0; i < cropTypes.length; ++i) {
      const elem = {}
      elem.name = cropTypes[i].name
      elem.description = cropTypes[i].description || '---'
      elem.createdAt = cropTypes[i].createdAt
      elem.active = cropTypes[i].active
      elem.id = cropTypes[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function CropTypesPage() {
  const [data, setData] = useState([])
  const [cropTypeId, setCropTypeId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-type-crop/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setCropTypeId(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }

  const columns = [
    { dataField: 'name', text: 'Name', sort: true },
    { dataField: 'description', text: 'Description', formatter: longTextFormatter, sort: true },
    { dataField: 'active', text: 'Active', align: 'center', headerAlign: 'center', formatter: booleanFormatter, sort: true },
    { dataField: 'createdAt', text: 'Created at', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getCropTypes().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get types of crops.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Types of crops list'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/edit-type-crop')}
              >
                Add new
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={'Are you sure you want to remove this type of crop?'}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCropType(cropTypeId).then(res => {
                if (res.status === 204 || res.status === 200 || res.status === 200) {
                  setRefresh(true)
                  alertSuccess({  title: 'Deleted!', customMessage: 'Type of crop removed successfully.' })
                }
              }).catch(error => {
                alertError({ error: error, customMessage: 'Could not remove type of crop.' })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
